import {publishEvent} from '../pub-sub';
import {ANALYTIC_EVENTS} from '../pub-sub/constants';

export const SHARING_COPY = 'copy link';

export const SharingEventLogger = {
  clickSharingIcon: layoutSection => publishEvent(ANALYTIC_EVENTS.SHARE_BUTTON_CLICK, {
    layoutSection
  }),
  closeSharingWindowByIcon: () => publishEvent(ANALYTIC_EVENTS.SHARE_WINDOW_CLOSE_BY_ICON),
  closeSharingByOverLay: () => publishEvent(ANALYTIC_EVENTS.SHARE_WINDOW_CLOSE_BY_OVERLAY),
  shareBySocial: socialName => publishEvent(ANALYTIC_EVENTS.SHARE_SOCIAL, {
    socialName
  }),
  clickArticleShareButton: (layoutSection, text) => publishEvent(ANALYTIC_EVENTS.SHARE_ARTICLE_BUTTON_CLICK, {
    layoutSection,
    text
  }),
  clickTrendShareButton: text => publishEvent(ANALYTIC_EVENTS.SHARE_TREND, {
    text
  })
};
